import { render, staticRenderFns } from "./FooterRegistartion.vue?vue&type=template&id=578a7ab6&scoped=true&"
import script from "./FooterRegistartion.vue?vue&type=script&lang=js&"
export * from "./FooterRegistartion.vue?vue&type=script&lang=js&"
import style0 from "./FooterRegistartion.vue?vue&type=style&index=0&id=578a7ab6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a7ab6",
  null
  
)

export default component.exports